"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Link = void 0;
const react_1 = __importDefault(require("react"));
const index_1 = require("../index");
const react_native_1 = require("react-native");
const Link_style_1 = require("./Link.style");
function Link({ children, style = [], underlined = false, href, }) {
    return (react_1.default.createElement(react_native_1.Pressable, null, ({ pressed, hovered, focused }) => (react_1.default.createElement(index_1.Text, { style: [
            ...(underlined ? [Link_style_1.styles.underlined] : []),
            ...(hovered ? [Link_style_1.styles.greenText] : []),
            ...style,
        ], onPress: () => react_native_1.Linking.openURL(href) }, children))));
}
exports.Link = Link;
